import _ from 'lodash';
import { AfterViewInit, Component, DestroyRef, ElementRef, HostListener, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { filter } from 'rxjs';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { PopoverService } from 'app/core/services/popover.service';
import { Store, select } from '@ngrx/store';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.scss']
})
export class UsersPageComponent implements OnInit, AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @ViewChild('users', { static: true }) usersRef: ElementRef;

  @HostListener('document:click', ['$event'])
  onHidePopover(event: MouseEvent) {
    if (window && window.getSelection && window.getSelection().toString().length) {
      return;
    }
    const { list } = this.popoverService;
    for(let key in list) {
      const popover = list[key];
      popover.hide();
    }
  }

  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user => !_.isNull(user))
  );

  public readonly: boolean = false;
  
  constructor(
    private store: Store,
    private sharedService: SharedService,
    private popoverService: PopoverService,
  ) {}

  ngOnInit(): void {
    this.sharedService.token = window['orgSignIn'].getAccessToken();

    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user: any) => {
      const { access } = user.loggedInUser ? user.loggedInUser: { access: [1] };
      this.readonly = access.findIndex(access => access == 1) >= 0 ? false: true;
    });
  }

  ngAfterViewInit(): void {
    const userStyles = window['documentManager'].createElement('link');
    userStyles.href = 'paybee-spa/styles.css?v=398';
    userStyles.rel = 'stylesheet';
    window['$'](this.usersRef.nativeElement).append(userStyles);
  }
  ngOnDestroy(): void {
    const $ = window['$'];
    $("#users").hide();
    $("#users").empty();
  }

}
